<template>
  <div class="container">
    <h1 class="h1 margin-bottom-0">Billing Profiles
      <sdx-menu-flyout v-if="isAdmin">
        <sdx-menu-flyout-toggle>
          <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
        </sdx-menu-flyout-toggle>
        <sdx-menu-flyout-content style="width: 600px;">
          <p>
            Link to send to customer to create his first billing profile:<br><a
              href="/billing/profiles/createbycustomer"
              class="btn btn-primary">/billing/profiles/createbycustomer</a><br/>
            <br/>
            Instruction to create customer in the Swisscom systems: <a href="https://wiki.swisscom.com/display/SEP/Billing+Arbeitsanweisung+Messaging+Neukunden+Onboading"
                                                                       target="wiki">Wiki</a><br/>
            <br/>
            <span style="color: red">Actual Workaround for private persons:<br/>
              - Billing Reference start with <b>"FREE-"</b><br/>
              - BackendContractId = <b>"WORKAROUND-PRIVATE-PERSON"</b></span>

          </p>
        </sdx-menu-flyout-content>
      </sdx-menu-flyout>
    </h1>
    <div class="row margin-bottom-1 margin-top-0">
      <div class="col-lg text-align-right ">
        <sdx-button
            v-if="showProfilesTable & isAdmin"
            id="createButton"
            name="CreateProfile"
            label="New"
            class="sdx-button-object"
            @click="this.$router.push('/billing/profiles/create');"
        />
      </div>
    </div>
    <sdx-loading-spinner id="spinner-profile" ref="spinnerProfile" size="large"
                         sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div class="row margin-bottom-2">
      <div class="col-xs-2" style="padding-top: 5px; padding-right: 0; min-width: 280px;">
        <span style="padding-right: 5px; font-size: 15px;">Company Name</span>
        <sdx-input
            data-testid="companyName"
            :value="company"
            @input="handleFieldChange('company', $event.target.value)"
        />
      </div>
      <div class="col-xs-2" style="padding-top: 5px; padding-right: 0; max-width: 160px;">
        <span style="padding-right: 5px; font-size: 15px">Billing Reference</span>
        <sdx-input
            data-testid="customerBillingReference"
            :value="customerBillingReference"
            @input="handleFieldChange('customerBillingReference', $event.target.value)"
        />
      </div>
      <div class="col-xs-2" style="padding-top: 5px; padding-right: 0; max-width: 170px;">
        <span style="padding-right: 5px; font-size: 15px">SCN</span>
        <sdx-input
            data-testid="scn"
            :value="scn"
            @input="handleFieldChange('scn', $event.target.value)"
        />
      </div>
      <div class="col-xs-2" style="padding-top: 5px; padding-right: 0; max-width: 184px;">
        <span style="padding-right: 5px; font-size: 15px">esBill Contract Id</span>
        <sdx-input
            data-testid="backendContractId"
            :value="backendContractId"
            @input="handleFieldChange('backendContractId', $event.target.value)"
        />
      </div>
      <div class="col-xs-2" style="padding-top: 5px; padding-right: 0; min-width: 260px;">
        <span style="padding-right: 5px; font-size: 15px">Bill Email</span>
        <sdx-input
            data-testid="billEmail"
            :value="billEmail"
            @input="handleFieldChange('billEmail', $event.target.value)"
        />
      </div>
      <div class="col-xs-2" style="padding-top: 5px; padding-right: 0; min-width: 260px;">
        <span style="padding-right: 5px; font-size: 15px">Archived</span><br/>
        <sdx-input-item
            :checked="this.archived"
            @click="toggleArchived(this.archived)"
        />
      </div>
    </div>
    <div id="profile" ref="profiles" v-if="showProfilesTable" class="margin-top-0 padding-top-0">
      <div v-if="showProfilesTable" class="profile-table table table--responsive table--highlight">
        <div class="table-wrapper">
          <table data-init="auto">
            <thead>
            <tr>
              <th class="table-header">
                Name
                <div class="toolbar__item item--show paddingIcon0">
                  <button aria-label="Sort"
                          data-testid="sort"
                          @click="sortProfiles('company')"
                  >
                    <sdx-icon icon-name="icon-arrows-double" size="1"></sdx-icon>
                  </button>
                </div>
              </th>
              <th class="table-header" v-if="isAdmin">Billing Reference<br/><i>used in DevApp</i>
                <div class="toolbar__item item--show paddingIcon0">
                  <button aria-label="Sort"
                          data-testid="sort"
                          @click="sortProfiles('customerBillingReference')"
                  >
                    <sdx-icon icon-name="icon-arrows-double" size="1"></sdx-icon>
                  </button>
                </div>
              </th>
              <th class="table-header">
                <span v-if="isAdmin">SCN<br/></span>
                <a href="https://www.zefix.ch" target="zefix">Zefix</a> / Birthday
                <div class="toolbar__item item--show paddingIcon0">
                  <button aria-label="Sort"
                          data-testid="sort"
                          @click="sortProfiles('zefix')"
                  >
                    <sdx-icon icon-name="icon-arrows-double" size="1"></sdx-icon>
                  </button>
                </div>
              </th>
              <th class="table-header" v-if="isAdmin">BackendContractId<br/>(esBill ContractId)
                <div class="toolbar__item item--show paddingIcon0">
                  <button aria-label="Sort"
                          data-testid="sort"
                          @click="sortProfiles('backendContractId')"
                  >
                    <sdx-icon icon-name="icon-arrows-double" size="1"></sdx-icon>
                  </button>
                </div>
              </th>
              <th class="table-header">Digital Billing Email
                <div class="toolbar__item item--show paddingIcon0">
                  <button aria-label="Sort"
                          data-testid="sort"
                          @click="sortProfiles('billEmail')"
                  >
                    <sdx-icon icon-name="icon-arrows-double" size="1"></sdx-icon>
                  </button>
                </div>
              </th>
              <th class="table-header" v-if="isAdmin">Updated
                <div class="toolbar__item item--show paddingIcon0">
                  <button aria-label="Sort"
                          data-testid="sort"
                          @click="sortProfiles('updatedOn')"
                  >
                    <sdx-icon icon-name="icon-arrows-double" size="1"></sdx-icon>
                  </button>
                </div>
              </th>
              <th class="table-header text-align-center">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr id="billingTable" v-for="item in billingProfiles" v-bind:key="item"
                :class="{ 'missing-data': (item.scn === undefined || item.scn === '' || item.backendContractId == undefined || item.backendContractId == '') }" >
              <td>
                <span v-if="item.company!=''">
                  {{ item.company }}
                </span>
                <span v-if="item.company==''">
                   {{ item.firstName }} {{ item.lastName }}
                </span>
                &nbsp;
                <sdx-menu-flyout v-if="isAdmin && item.comment">
                  <sdx-menu-flyout-toggle>
                    <sdx-icon icon-name="icon-information-circle" sr-hint="Read more"></sdx-icon>
                  </sdx-menu-flyout-toggle>
                  <sdx-menu-flyout-content style="width: 600px;">
                    <p>{{ item.comment }}</p>
                  </sdx-menu-flyout-content>
                </sdx-menu-flyout>
              </td>
              <td v-if="isAdmin">
                {{ item.customerBillingReference }}
              </td>
              <td>
                <span v-if="isAdmin">{{ item.scn }}<br/></span>
                <span v-if="item.company!=''">
                  <a :href="'https://www.zefix.ch/de/search/entity/list?mainSearch='+ item.zefix  +'&searchTypeExact=true'"
                     target="zefix">{{ item.zefix }}</a>
                </span>
                <span v-if="item.company==''">{{ item.birthday }}</span>
              </td>
              <td v-if="isAdmin">
                {{ item.backendContractId }}
              </td>
              <td>{{ item.billEmail }}</td>
              <td v-if="isAdmin" :title="'Created: ' + formatDate(item.createdOn)">
                {{ formatDate(item.updatedOn) }}
              </td>
              <td>
                <div class="toolbar text-align-center" id="toolbar01">
                  <div v-if="isAdmin" class="toolbar__item item--show" style="padding-left: 5px">
                    <button aria-label="Edit"
                            id="editActionButton"
                            @click="saveAndGoToRoute(item.profileId, '/billing/profiles/edit')">
                      <i class="icon icon-edit" title="Edit"></i>
                    </button>
                  </div>
                  <div class="toolbar__item item--show" style="padding-left: 5px;">
                    <button aria-label="Detail"
                            id="detailActionButton"
                            @click="saveAndGoToRoute(item.profileId, '/billing/profiles/view/admin')">
                      <i class="icon icon-eye" title="Detail"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-between">
        <div class="col-xs">
          <div v-if="totalPages != 1" class="sms-outbox-pagination">
            <div v-bind:current-page="currentPage.number + 1" v-bind:total-pages="Math.ceil(totalElements / size)"
                 @pageChanged="search">
              <ul v-if="totalPages > 0" class="pagination">
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label="<<"
                      class="sdx-button"
                      @click="gotoPage(1)"
                      :disabled="isFirstPage"/>
                </li>
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label="<"
                      class="sdx-button"
                      @click="gotoPage(currentPage - 1)"
                      :disabled="isFirstPage"/>
                </li>
                <li v-for="page in pages" v-bind:key="page" class="pagination-item">
                      <span
                          v-if="page.placeholder"
                          class="pagination-button inactive"
                      >
                        ...
                      </span>
                  <button
                      v-else
                      type="button"
                      class="pagination-button"
                      @click="gotoPage(page.pageNumber)"
                      :class="`${page.currentPage ? 'active' : 'inactive'}`"
                  >
                    {{ page.pageNumber }}
                  </button>
                </li>
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label=">"
                      class="sdx-button"
                      @click="gotoPage(currentPage + 1)"
                      :disabled="isLastPage"/>
                </li>
                <li class="pagination-item">
                  <sdx-button
                      type="button"
                      label=">>"
                      class="sdx-button"
                      @click="gotoPage(totalPages)"
                      :disabled="isLastPage"/>
                </li>
                <li class="pagination-item total-elements">
                  Total: {{ this.totalElements }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import billingService from '../service'
import loadingSpinnerService from "@/services/loading-spinner.service";
import {logger} from "@/services/logger.service";
import userService from "@/services/user.service";
import {showAlert} from "@/services/notification.service";
import {formatDate} from "@/util/utility";

export default {
  data: function () {
    return {
      billingProfiles: [],
      totalPages: -1,
      pageNumber: -1,
      currentPage: -1,
      totalElements: -1,
      size: -1,
      page: [],
      showProfilesTable: false,
      isAdmin: false,
      sortColumn: 'name',
      sortOrder: 'ASC, DESC',
      currentSort: "customerBillingReference",
      clickCount: {},
      company: [],
      customerBillingReference: [],
      scn: [],
      backendContractId: [],
      billEmail: [],
      archived: false
    }
  },
  computed: {
    pages: function () {
      let previousPage = this.currentPage > 1 ? (this.currentPage - 1) : 1
      let nextPage = this.currentPage < this.totalPages ? (this.currentPage + 1) : this.totalPages
      let extraPreviousPage = previousPage === 3 ? 2 : null
      let extraNextPage = nextPage === (this.totalPages - 2) ? (this.totalPages - 1) : null
      let placeholderBefore = previousPage > 3 ? 2 : null
      let placeholderAfter = nextPage < (this.totalPages - 2) ? (this.totalPages - 1) : null

      let pages = []

      for (let i = 1; i <= this.totalPages; i += 1) {
        if ([1, this.totalPages, this.currentPage, previousPage, nextPage, extraPreviousPage, extraNextPage, placeholderBefore, placeholderAfter].includes(i)) {
          pages.push({
            pageNumber: i,
            currentPage: this.currentPage === i,
            placeholder: [placeholderBefore, placeholderAfter].includes(i)
          })
        }
      }
      return pages
    },
    isFirstPage: function () {
      return this.currentPage === 1
    },
    isLastPage: function () {
      return this.currentPage === this.totalPages
    },
  },
  mounted() {
    loadingSpinnerService.showByRef(this.$refs.spinnerProfile, this.$refs.profiles)
    this.loadProfiles(this.currentPage);
    this.showAdminView();
    loadingSpinnerService.hideByRef(this.$refs.spinnerProfile, this.$refs.profiles)
  },
  methods: {
    formatDate,
    showAdminView: async function () {
      return this.isAdmin = await userService.isAtLeastAdminWithoutFmg();
    },
    loadProfiles: async function (page) {
      console.log('loadProfiles: archived:', this.archived);
      if (page === undefined)
        page = billingService.getBillingProfilePage();
      else
        billingService.setBillingProfilePage(page);
      try {

        let response ;
        if(this.archived)
          response= await billingService.getArchivedBillingProfiles(this.company, this.customerBillingReference, this.scn, this.backendContractId, this.billEmail, page - 1, 20, this.currentSort);
        else
          response= await billingService.getActiveBillingProfiles(this.company, this.customerBillingReference, this.scn, this.backendContractId, this.billEmail, page - 1, 20, this.currentSort);
        this.billingProfiles = response.data.content;
        this.totalPages = response.data.totalPages;
        this.pageNumber = response.data.pageNumber;
        this.currentPage = response.data.number + 1;
        this.totalElements = this.billingProfiles.length;
        this.size = response.data.size;
        this.showProfilesTable = true;
      } catch (error) {
        this.billingProfiles = []
        showAlert(error.message)
      }
    },
    gotoPage: function (page) {
      this.loadProfiles(page);
      this.$emit('pageChanged', page);
    },
    saveAndGoToRoute(profileId, route) {
      logger.debug("Save ProfileId: " + profileId)
      try {
        billingService.setBillingProfileIdToSession(profileId);
        this.$router.push(route);
      } catch (error) {
        showAlert(error.message)
      }
    },
    sortProfiles(column) {
      if (column !== undefined && column !== null) {
        this.currentSort = column
      }
      if (!this.clickCount[column]) {
        this.clickCount[column] = 0;
      }
      if (this.sortColumn === column) {
        this.clickCount[column]++;
      } else {
        this.sortColumn = column;
        this.clickCount[column] = 2;
        this.sortOrder = 'ASC';
      }
      if (this.clickCount[column] === 1) {
        this.sortOrder = 'DESC'

        this.clickCount[column] = 0;
      } else {
        this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
      }
      console.log('Sortierung richtung:', this.sortOrder)
      console.log('Sortiere nach:', this.currentSort);
      this.currentSort = `${this.sortColumn},${this.sortOrder}`;
      this.loadProfiles(this.currentPage);
    },
    handleFieldChange: function (field, value) {
      this[field] = value;
      this.loadProfiles(1);
    },
    toggleArchived: function (archived) {
      console.log('toggleArchived: new value:', archived);
      this.archived = !archived;
      this.loadProfiles(1);
    },
    watch: {
      page: function () {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style>


.profile-table .table-header {
  padding-top: 20px;
  padding-bottom: 17px;
}

.profile-table .table-cell {
  padding-top: 5px;
  padding-bottom: 2px;
}

.profile-table .table-cell {
  border-radius: 20px;
}

.profile-table.table tbody td {
  padding-top: 5px;
  padding-bottom: 3px;
}

.paddingIcon0 {
  padding: 0 !important;
}

.missing-data {
  background-color: #f6dadc;
}

.table-header sdx-icon {
  margin-left: 10px;
  transform: rotate(90deg);
}
</style>